import facturaReducer from './facturaReducer';

export default facturaReducer;